import { useState } from 'react';
import { ALLOWED_FORMATS, validateFileSize } from '../utils/fileValidation';

export const useIdentificationUpload = () => {
  const [identificationType, setIdentificationType] = useState();
  const [fileListFront, setFileListFront] = useState([]);
  const [fileListBack, setFileListBack] = useState([]);
  const [fileListPassport, setFileListPassport] = useState([]);

  const [fileValidate, setFileValidate] = useState(false);
  const [fileSizeValidate, setFileSizeValidate] = useState(false);
  const [fileFrontValidate, setFileFrontValidate] = useState(false);
  const [fileFrontSizeValidate, setFileFrontSizeValidate] = useState(false);
  const [fileBackValidate, setFileBackValidate] = useState(false);
  const [fileBackSizeValidate, setFileBackSizeValidate] = useState(false);

  const onChangeFront = ({ fileList: newFileList }) => setFileListFront(newFileList);
  const onChangeBack = ({ fileList: newFileList }) => setFileListBack(newFileList);
  const onChangePassport = ({ fileList: newFileList }) => setFileListPassport(newFileList);

  const beforeUpload = async (file, value) => {
    const validSize = validateFileSize(file?.size);

    if (!ALLOWED_FORMATS.includes(file.type)) {
      if (value === 'front') {
        setFileFrontValidate(true);
      } else if (value === 'back') {
        setFileBackValidate(true);
      } else {
        setFileValidate(true);
      }
    } else if (!validSize) {
      if (value === 'front') {
        setFileFrontSizeValidate(true);
      } else if (value === 'back') {
        setFileBackSizeValidate(true);
      } else {
        setFileSizeValidate(true);
      }
    }
    return false;
  };

  const handleRemoveUploaded = (fileId, value) => {
    if (identificationType === 'passport') {
      setFileListPassport((prevFileList) => prevFileList.filter((item) => item.uid !== fileId));
      setFileValidate(false);
      setFileSizeValidate(false);
    } else {
      setFileListFront((prevFileList) => prevFileList.filter((item) => item.uid !== fileId));
      setFileListBack((prevFileList) => prevFileList.filter((item) => item.uid !== fileId));
      if (value === 'front') {
        setFileFrontSizeValidate(false);
        setFileFrontValidate(false);
      } else if (value === 'back') {
        setFileBackSizeValidate(false);
        setFileBackValidate(false);
      }
    }
  };

  const resetIdentificationState = () => {
    setIdentificationType(undefined);
    setFileListFront([]);
    setFileListBack([]);
    setFileListPassport([]);
    setFileValidate(false);
    setFileSizeValidate(false);
    setFileFrontValidate(false);
    setFileFrontSizeValidate(false);
    setFileBackValidate(false);
    setFileBackSizeValidate(false);
  };

  const handleIdentificationChange = (value) => {
    resetIdentificationState();
    setIdentificationType(value);
  };

  const buildUploadsData = () => {
    const uploadsData = [];
    switch (identificationType) {
      case 'passport': {
        uploadsData.push({
          fileType: fileListPassport[0]?.name?.split('.')?.pop()?.toLowerCase(),
          docType: 'Passport',
          displayView: 'Front',
          file: fileListPassport[0]?.originFileObj,
        });
        break;
      }
      case 'license': {
        if (fileListFront.length > 0) {
          uploadsData.push({
            fileType: fileListFront[0]?.name?.split('.')?.pop()?.toLowerCase(),
            docType: 'Driving License',
            displayView: 'Front',
            file: fileListFront[0]?.originFileObj,
          });
        }
        if (fileListBack.length > 0) {
          uploadsData.push({
            fileType: fileListBack[0]?.name?.split('.')?.pop()?.toLowerCase(),
            docType: 'Driving License',
            displayView: 'Back',
            file: fileListBack[0]?.originFileObj,
          });
        }
        break;
      }
      default:
        break;
    }
    return uploadsData;
  };

  const isUploadInvalid = fileValidate || fileSizeValidate || fileFrontValidate || fileFrontSizeValidate || fileBackValidate || fileBackSizeValidate;

  const isUploadIncomplete =
    !identificationType ||
    (identificationType === 'passport' ? fileListPassport.length === 0 : (fileListFront.length && fileListBack.length) === 0);

  return {
    identificationType,
    setIdentificationType,
    fileListFront,
    fileListBack,
    fileListPassport,
    fileValidate,
    fileSizeValidate,
    fileFrontValidate,
    fileFrontSizeValidate,
    fileBackValidate,
    fileBackSizeValidate,
    onChangeFront,
    onChangeBack,
    onChangePassport,
    beforeUpload,
    handleRemoveUploaded,
    handleIdentificationChange,
    resetIdentificationState,
    buildUploadsData,
    isUploadInvalid,
    isUploadIncomplete,
  };
};
